export const DEFAULT_PRODUCT_GRID_SIZE = 12;
export const DEFAULT_COLOR_GRID_SIZE = 15;
